import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { RoutesApp } from './routes'
import { ProviderContext } from './contexts/auth'

import { GlobalStyle } from './styles/global'

import 'react-toastify/dist/ReactToastify.css'

export function App() {
  return (
    <BrowserRouter>
      <ProviderContext>
        <GlobalStyle />
        <ToastContainer autoClose={3000} />
        <RoutesApp />
      </ProviderContext>
    </BrowserRouter>
  )
}